import { useEffect } from 'react';

type UseShowHeaderProps = {
  shouldHide: boolean;
};

export const useShowHeader = ({ shouldHide }: UseShowHeaderProps) => {
  useEffect(() => {
    if (shouldHide) {
      window.hideRailsHeaderInMobile?.();
    } else {
      window.showRailsHeaderInMobile?.();
    }
  }, [shouldHide]);
};
